import { IPurchase } from '@snackpass/snackpass-types';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { IOrderStatus } from 'src/modules/Types';
import { getActivePurchasesSorted } from '../../../../modules/Redux';
import {
    getFirstName,
    normalizedOrderStatus,
} from '../../../../modules/Utils/helpers';
import { useAnnouncer } from './useAnnouncer';
import { getAnnouncement } from '../lib';

export const useInitAnnouncer = () => {
    const purchases = useSelector(getActivePurchasesSorted);

    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);

    const prevPurchasesRef = useRef<IPurchase[]>([]);
    const { announce } = useAnnouncer();

    // detect moved to ready orders
    useEffect(() => {
        if (initialLoadCompleted) {
            const prevPurchasesStatusLookup = prevPurchasesRef.current.reduce(
                (lookup, purchase) => {
                    lookup[purchase._id] = normalizedOrderStatus(purchase);
                    return lookup;
                },
                {} as Record<string, IOrderStatus>
            );

            purchases.forEach(purchase => {
                const status = normalizedOrderStatus(purchase);
                const prevStatus = prevPurchasesStatusLookup[purchase._id];
                const message = getAnnouncement(
                    purchase.receiptNumber,
                    getFirstName(purchase?.user?.name)
                );
                const movedToReady =
                    status === IOrderStatus.Ready &&
                    prevStatus !== IOrderStatus.Ready;
                if (movedToReady) {
                    announce(message);
                }
            });
        }

        prevPurchasesRef.current = purchases;
    }, [purchases, announce]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setInitialLoadCompleted(true);
        }, 5000); // 5000 milliseconds = 5 seconds

        return () => {
            clearTimeout(timer); // clear the timer if the component is unmounted before the 5 seconds pass
        };
    }, []);
};
